import { COLOR_TERTIARY } from "../../theme";
import styled from "@emotion/styled";
import { Paragraph, ParagraphHeader } from "../../typography/Paragraph";

interface AttorneyLeaderboardCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
}

const AttorneyLeaderboardCardContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLOR_TERTIARY};
  padding: 24px 16px;
  border-radius: 8px;
  gap: 16px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledParagraph = styled(Paragraph)`
  font-size: 24px;
`;

const AttorneyLeaderboardCard = ({
  icon,
  title,
  value,
}: AttorneyLeaderboardCardProps) => {
  return (
    <AttorneyLeaderboardCardContainer>
      {icon}
      <InfoContainer>
        <ParagraphHeader>{title}</ParagraphHeader>
        <StyledParagraph fontWeight={500}>{value}</StyledParagraph>
      </InfoContainer>
    </AttorneyLeaderboardCardContainer>
  );
};

export default AttorneyLeaderboardCard;
